"use strict";

exports.__esModule = true;
exports.labelTextSizes = exports.dataHooks = void 0;
var dataHooks = {
  input: 'checkbox-input',
  label: 'checkbox-label',
  boxTooltip: 'checkbox-box-tooltip',
  box: 'checkbox-box',
  children: 'checkbox-children'
};
exports.dataHooks = dataHooks;
var labelTextSizes = {
  small: 'small',
  medium: 'medium'
};
exports.labelTextSizes = labelTextSizes;
//# sourceMappingURL=constants.js.map